// src/firebaseConfig.js
// Manages Firebase initializations for both Automateit (primary)
// and a potential secondary project for other functions.

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// --- Configuration for Primary Firebase Project (Automateit) ---
const primaryFirebaseConfigValues = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Primary Firebase App (Automateit) as a named instance
const primaryApp = initializeApp(primaryFirebaseConfigValues, "primary");

// Initialize and export services from the primary app
const auth = getAuth(primaryApp);
const storage = getStorage(primaryApp);
const db = getFirestore(primaryApp);
const functionsPrimary = getFunctions(primaryApp);


// --- Configuration for a potential Secondary Firebase Project ---
// This part of your config is preserved for other features that might need it.
const secondaryFirebaseConfigValues = {
  apiKey: process.env.REACT_APP_SECONDARY_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_SECONDARY_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_SECONDARY_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_SECONDARY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_SECONDARY_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_SECONDARY_FIREBASE_APP_ID,
};

let functionsSecondary;
if (secondaryFirebaseConfigValues.projectId) {
    const secondaryApp = initializeApp(secondaryFirebaseConfigValues, "secondary");
    functionsSecondary = getFunctions(secondaryApp);
}

// Export the instances for use in other parts of your app
export {
  primaryApp,
  auth,
  storage,
  db,
  functionsPrimary, // This is what we will use
  functionsSecondary,
  primaryFirebaseConfigValues as firebaseConfig,
};